export const handleAttestation = function () { 

    const cookieConsent = '_krest_attestation_consent';

    let assetationModal = $('#assetationModal');
    let assetationAcceptModal = $('#assetationAcceptModal');
    let assetationNoAccess = $('#assetationNoAccessModal');
  
    let cookie_consent = getCookie( cookieConsent );
    let country;
  
    if ( cookie_consent !== "1" ) { 

        attestation_main();

    }

    // -------------------------------- Main Important Notice Form ------------------------------------

    function attestation_main() {

        // Main form
        assetationModal.on('hide.bs.modal', function (e) {
            e.preventDefault();
            e.stopPropagation();

            return false;
        });

        // Country change
        $( "#attestationCountry" ).on('change', function() {

            var countryElement = document.getElementById("attestationCountry");
            country = countryElement.value;

        });

        // Country Checkbox check
        const assetationMainCountryAcceptSubmit = document.getElementById('attestationCountry');
        const assetationMainOtherCountryCheckbox = document.getElementById('assetation-accept-other-country-checkbox');

        // Country Other Checkbox check
        assetationMainOtherCountryCheckbox.addEventListener('change', (event) => {

            if ( event.currentTarget.checked ) {
                
                assetationMainCountryAcceptSubmit.selectedIndex = 0;
                assetationMainCountryAcceptSubmit.disabled = true;

            } else {

                assetationMainCountryAcceptSubmit.disabled = false;

            }
        });

             
        assetationModal.modal('show');

    }

    // Validate fields
    var forms = document.querySelectorAll('.assetation-needs-validation');

    Array.prototype.slice.call(forms)    
        
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {

                const assetationMainOtherCountryCheckbox = document.getElementById('assetation-accept-other-country-checkbox');

                if ( assetationMainOtherCountryCheckbox.checked ) {

                    acceptCookieConsent();

                    $('.modal-backdrop.show').remove();

                } else {

                    if (!form.checkValidity()) {
                        event.preventDefault();
                        event.stopPropagation();
                    } 

                    form.classList.add('was-validated');

                    if ( form.checkValidity() ) {

                        country = document.getElementById('attestationCountry').value;

                        if ( country === 'united-states') {

                            deleteCookie( cookieConsent );
                            setCookie( cookieConsent, 1, 90 );

                            assetationModal.remove();

                            $('.modal-backdrop.show').remove();
                            document.body.style.overflowY = "scroll";

                        } else if ( country === 'united-kingdom') {

                            $("#accept_uk_disclaimer").css("display", "block");
                            $("#accept_singapore_disclaimer").css("display", "none");

                            attestation_form_accept();
                        
                        } else if ( country === 'singapore') {
                         
                            $("#accept_singapore_disclaimer").css("display", "block");
                            $("#accept_uk_disclaimer").css("display", "none");

                            attestation_form_accept();

                        } else if ( country === 'other') {

                            display_no_access();

                        }

                        return false;
                    }

                }
        
            }, false);

    })



    // ----------------------------------- Acceptance form ----------------------------------------------------

    function attestation_form_accept() {

        // Modal Form
        assetationAcceptModal.on('hide.bs.modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });


        $("#assetationAcceptModal").css("display", "block");

        assetationAcceptModal.modal('show');

        if ( document.getElementsByClassName('modal-backdrop show').length == 2 ) {

           $('.modal-backdrop.show')[0].remove();
                  
        }
       
    }

    // Checkbox check
    const assetationCheckbox = document.getElementById('assetation-accept-checkbox');
    const assetationAcceptSubmit = document.getElementById('accept-submit');

    assetationCheckbox.addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
            
            assetationAcceptSubmit.disabled = false;

        } else {

            assetationAcceptSubmit.disabled = true;

        }
    });

    // Go Back button
    const acceptGoBackElement = document.getElementById( 'accept-go-back' );
    acceptGoBackElement.addEventListener( 'click', acceptGoBack );

    function acceptGoBack() {

       $("#assetationAcceptModal").removeClass("show");
       $("#assetationAcceptModal").css("display", "none");
    
    }


    // Accept Submit button
    const acceptSubmit = document.getElementById( 'accept-submit' );
    acceptSubmit.addEventListener( 'click', acceptCookieConsent );

    function acceptCookieConsent() {

        deleteCookie( cookieConsent );
        setCookie( cookieConsent, 1, 90 );

        assetationModal.remove();
        assetationAcceptModal.remove();

       $('.modal-backdrop.show').remove();
        document.body.style.overflowY = "scroll";


    }

    // -------------------------------------- No Access --------------------------------------

    function display_no_access() {

        // Modal Form
        assetationNoAccess.on('hide.bs.modal', function (e) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $('.modal-backdrop.show').remove();

        assetationModal.remove();
        assetationNoAccess.modal('show');

    }

    assetationModal.on('submit', function (event) {
        event.preventDefault();
    });

    // ------------------------------------ Cookie Functions -----------------------------------

    function getCookie( cname ) {

        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split( ';' );
        for( let i = 0; i <ca.length; i++ ) {
            let c = ca[i];
            while ( c.charAt(0) == ' ' ) {
                c = c.substring(1);
            }
            if ( c.indexOf( name ) == 0 ) {
                return c.substring( name.length, c.length );
            }
        }

        return "";
    }

    function setCookie( cname, cvalue, exdays ) {
        const d = new Date();
        d.setTime( d.getTime() + (exdays*24*60*60*1000) );
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function deleteCookie( cname ) {

        document.cookie = cname + "=;" + ";max-age=0;path=/";

    }

}
